import * as React from 'react';
import { Config } from './Config';
import { MainHandler } from './MainHandler';
import { ProductInterface } from './Model/Product';
import { LocalizationUtility } from './Service/LocalizationUtility';
import { ServiceLocator } from './ServiceLocator';

export class AppContext<M extends ProductInterface> {
    public readonly serviceLocator: ServiceLocator;
    public readonly handler: MainHandler<M>;
    public readonly config: Config;
    public readonly i18n: LocalizationUtility;

    constructor(
        serviceLocator: ServiceLocator,
        handler: MainHandler<M>,
        i18n: LocalizationUtility,
        config: Config
    ) {
        this.serviceLocator = serviceLocator;
        this.handler = handler;
        this.i18n = i18n;
        this.config = config;
    }

    get basePath(): string {
        return this.config.basePath;
    }
}

export const AppContextType = React.createContext((null as any) as AppContext<any>);
